<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
      dense
      flat
    >
      <v-btn icon @click="$router.push(`/${gluidId}`)"
        ><v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-menu offset-y max-height="300px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              dark
              v-bind="attrs"
              v-on="on"
              @click="$store.dispatch('fetchAllUserSpacesForUser')"
            >
              {{ currentSpace.replace("-", " ") }}
            </v-btn>
          </template>
          <v-list v-if="userSpaces">
            <v-list-item
              v-for="(space, i) in userSpaces"
              :key="i"
              @click="$router.push(`/${space.slug}`)"
            >
              <v-list-item-title>
                {{ space.title }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openNewSpaceDialog = true">
              <v-list-item-title>Create new space... </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list v-else
            ><v-list-item>
              <v-progress-circular
                indeterminate
              ></v-progress-circular> </v-list-item
          ></v-list>
        </v-menu>
      </v-toolbar-title>
      <!-- <v-text-field
        dense
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      /> -->
      <v-spacer />
      <v-toolbar-title>{{ firstName + " " + lastName }}</v-toolbar-title>
      <!--    Used to open the options menu -->
      <v-menu transition="slide-y-transition" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="signOutDialog = true">
            <v-list-item-title class="red--text">Sign Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app absolute clipped width="400px">
      <space-treeview :treeData="activeSpaceTreeArray" />
    </v-navigation-drawer>

    <!-- Used to Sign out -->
    <v-dialog v-model="signOutDialog" width="800px">
      <v-card>
        <v-card-title> Sign Out? </v-card-title>
        <v-card-subtitle>Are you sure you want to sign out?</v-card-subtitle>
        <v-card-actions>
          <v-btn @click="signOutDialog = false"> Cancel </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            class="white--text"
            @click="signOutAndRedirectToLogin"
          >
            Sign out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- used to view all spaces -->
    <v-dialog v-model="overviewSpacesDialog" width="800px">
      <v-list v-if="!userSpaces">
        <v-list-item-group>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Fetching workspaces </v-list-item-title>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-list v-if="userSpaces">
        <v-list-item-group>
          <v-list-item
            v-for="(userSpace, j) in userSpaces"
            :key="j"
            @click="navigateToSpace(userSpace)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ userSpace.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="showAddSpaceDialog">
            <v-list-item-icon>
              <v-icon> mdi-plus </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-dialog>

    <!--     used to create new spaces -->
    <v-dialog v-model="openNewSpaceDialog" width="800px">
      <v-card>
        <v-card-title class="grey darken-2">Add new space</v-card-title>
        <v-container>
          <h1>Space title:</h1>
          <v-text-field v-model="newSpaceTitle" />
          <p v-if="newSpaceTitleError" class="error">
            {{ newSpaceTitleError }}
          </p>
        </v-container>
        <v-card-actions>
          <v-btn @click="createSpace">Create Space</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
import router from "@/router";
import { mapGetters, mapActions } from "vuex";
import { dashCase } from "@/../api/_lib/utils/dashCase";
import SpaceTreeview from "@/components/app/SpaceTreeviewHeTree";

export default {
  data() {
    return {
      overviewSpacesDialog: false,
      openNewSpaceDialog: false,
      signOutDialog: false,
      newSpaceTitle: null,
      newSpaceTitleError: null,
      drawer: null,
      firstName: null,
      lastName: null,
      previousActiveSpaceTree: null,
    };
  },
  components: {
    SpaceTreeview,
  },
  mounted() {
    store.dispatch("cognito/fetchSession").then((userInfo) => {
      this.firstName = userInfo.idToken.payload.given_name;
      this.lastName = userInfo.idToken.payload.name;
    });
  },
  methods: {
    ...mapActions("cognito", ["signOut"]),
    signOutAndRedirectToLogin() {
      this.signOut();
      router.push("/login");
      store.commit("resetApp");
    },
    async openOverviewUserSpacesDialogAndFetchSpaces() {
      this.overviewSpacesDialog = true;
      await store.dispatch("fetchAllUserSpacesForUser");
    },
    navigateToSpace(space) {
      router.push(`/${space.slug}`);
      this.overviewSpacesDialog = false;
    },
    showAddSpaceDialog() {
      this.overviewSpacesDialog = false;
      this.openNewSpaceDialog = true;
    },
    async createSpace() {
      this.newSpaceTitleError = null;
      try {
        const { data } = await store.dispatch(
          "createNewSpaceAndDocumentForUser",
          this.newSpaceTitle
        );
        const gluidIdAndSlug = data.slug.split("/");
        const gluidId = gluidIdAndSlug.shift();
        const slug = gluidIdAndSlug.join("/");
        await router.push(`/${gluidId}/${dashCase(slug).trim()}`);
        this.openNewSpaceDialog = false;
      } catch (err) {
        this.newSpaceTitleError = err;
      }
    },
  },
  computed: {
    ...mapGetters(["userSpaces", "activeSpace", "activeSpaceTree"]),
    currentSpace() {
      return this.$route.path.split("/").slice(2, 3).join();
    },
    gluidId() {
      return this.$route.path.split("/").slice(1, 2).join();
    },
    activeSpaceTreeArray() {
      return [this.activeSpaceTree];
    },
  },
};
</script>
